// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".promptModal-modal{border-radius:var(--border-radius);overflow:scroll;max-height:100vh}.promptModal-modal ::-webkit-scrollbar-corner{background:transparent}", ""]);
// Exports
module.exports = exports;
